// export { default as Form } from "./Form"

import Form from "./Form"

export default Form
